import React from 'react';
import { FileText, ExternalLink, X } from 'lucide-react';
import Button from '../../common/Button.js';
import { useTranslation } from 'react-i18next';


const ViewExternalCommissionPaymentModal = ({ payment, vehicleOwnerName, onClose }) => {
  const { t } = useTranslation();
  if (!payment) return null;

  const fmt = (n) => `₹${Math.round(parseFloat(n || 0)).toLocaleString('en-IN')}`;
  const isPay = payment.direction === 'PAY_TO_OWNER';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-lg max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between p-4 border-b border-gray-200 sticky top-0 bg-white z-10">
          <div>
            <h2 className="text-lg font-semibold text-gray-800">Payment Details</h2>
            <p className="text-xs text-gray-500 font-mono">{payment.payment_id}</p>
          </div>
          <button type="button" onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="p-4 space-y-4">
          <div className={`text-center rounded-lg p-4 border ${isPay ? 'bg-blue-50 border-blue-200' : 'bg-orange-50 border-orange-200'}`}>
            <p className={`text-xs ${isPay ? 'text-blue-600' : 'text-orange-600'}`}>Amount</p>
            <p className={`text-3xl font-bold ${isPay ? 'text-blue-600' : 'text-orange-600'}`}>{fmt(payment.amount)}</p>
            <p className="text-sm text-gray-600 mt-1">
              {isPay ? 'Pay to Vehicle Owner' : 'Receive from Vehicle Owner'}
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
            <div><span className="text-gray-500">Commission</span><p className="font-semibold">{payment.external_commission_id}</p></div>
            <div><span className="text-gray-500">Vehicle Owner</span><p className="font-semibold">{vehicleOwnerName || payment.vehicle_owner_name || '—'}</p></div>
            <div><span className="text-gray-500">Date</span><p className="font-semibold">{payment.payment_date ? new Date(payment.payment_date).toLocaleDateString('en-IN') : '—'}</p></div>
            <div><span className="text-gray-500">Mode</span><p className="font-semibold">{payment.payment_mode || '—'}</p></div>
            <div><span className="text-gray-500">Transaction Ref</span><p className="font-semibold">{payment.transaction_ref || '—'}</p></div>
            <div><span className="text-gray-500">Shipments Synced</span><p className="font-semibold">{payment.sync_shipments ? t('common.yes') : t('common.no')}</p></div>
          </div>

          {payment.remarks && (
            <div className="text-sm">
              <span className="text-gray-500">Remarks</span>
              <p className="font-medium mt-1">{payment.remarks}</p>
            </div>
          )}

          <div className="border-t pt-4">
            <p className="text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
              <FileText className="w-4 h-4" /> Receipt / Proof
            </p>
            {payment.file_attachment ? (
              <a
                href={payment.file_attachment}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-blue-600 hover:underline text-sm"
              >
                View receipt <ExternalLink className="w-4 h-4" />
              </a>
            ) : (
              <p className="text-gray-500 text-sm">No receipt uploaded</p>
            )}
          </div>

          <div className="flex gap-2 justify-end pt-2">
            <Button type="button" variant="primary" onClick={onClose}>Close</Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewExternalCommissionPaymentModal;
